export default __webpack_public_path__ + "static/easy_sales-16a82c80602d0456b10c4e950fa39222.svg";